import React from "react"
import { Paper, Tabs, Tab } from "material-ui"
import DashboardWorkingEmployeeDetail from "./dashboard_detail/DashboardWorkingEmployeeDetail"
import DashboardOvertimeDetail from "./dashboard_detail/DashboardOvertimeDetail"
import { EDashboardDetailType, EOTEmployeeType, IDate } from "../../models"
import strings from "../../localization/strings"
import { amber500 } from "material-ui/styles/colors"
interface IProps {
    utcTime: IDate
    globalHierarchyItemId: string
    filterByPunchPermissionHierarchy: boolean
    filterDirectReportsOnly: boolean
    activatedTab: EDashboardDetailType
    handleChangeActivatedTab(activatedTab: EDashboardDetailType): void
}

const DashboardDetail: React.SFC<IProps> = (props: IProps) => {
    return (
        <Paper zDepth={1} style={{ textAlign: "left", marginTop: 20 }}>
            <Tabs
                value={props.activatedTab}
                onChange={activatedTab => props.handleChangeActivatedTab(activatedTab)}
            >
                <Tab
                    value={EDashboardDetailType.WorkingEmployee}
                    label={
                        <span>
                            {strings.Working_Employees}
                            {props.activatedTab === EDashboardDetailType.WorkingEmployee &&
                                <i
                                    className="fa fa-info-circle"
                                    style={{ color: amber500, fontSize: 16, marginLeft: 10 }}
                                    title={strings.WorkingEmployeeTooltip}
                                />
                            }
                        </span>
                    }
                >
                    {props.activatedTab === EDashboardDetailType.WorkingEmployee &&
                        <DashboardWorkingEmployeeDetail
                            utcTime={props.utcTime}
                            globalHierarchyItemId={props.globalHierarchyItemId}
                            filterByPunchPermissionHierarchy={props.filterByPunchPermissionHierarchy}
                            filterDirectReportsOnly={props.filterDirectReportsOnly}
                        />
                    }
                </Tab>
                <Tab
                    value={EDashboardDetailType.ApproachingOT}
                    label={
                        <span>
                            {strings.Approaching_Overtime}
                            {props.activatedTab === EDashboardDetailType.ApproachingOT &&
                                <i
                                    className="fa fa-info-circle"
                                    style={{ color: amber500, fontSize: 16, marginLeft: 10 }}
                                    title={strings.ApproachingOvertimeTooltip}
                                />
                            }
                        </span>
                    }
                >
                    {props.activatedTab === EDashboardDetailType.ApproachingOT &&
                        <DashboardOvertimeDetail
                            type={EOTEmployeeType.ApproachingOT}
                            utcTime={props.utcTime}
                            globalHierarchyItemId={props.globalHierarchyItemId}
                            filterByPunchPermissionHierarchy={props.filterByPunchPermissionHierarchy}
                            filterDirectReportsOnly={props.filterDirectReportsOnly}
                        />
                    }
                </Tab>
                <Tab
                    value={EDashboardDetailType.OT}
                    label={
                        <span>
                            {strings.Overtime}
                            {props.activatedTab === EDashboardDetailType.OT &&
                                <i
                                    className="fa fa-info-circle"
                                    style={{ color: amber500, fontSize: 16, marginLeft: 10 }}
                                    title={strings.OvertimeTooltip}
                                />
                            }
                        </span>
                    }
                >
                    {props.activatedTab === EDashboardDetailType.OT &&
                        <DashboardOvertimeDetail
                            type={EOTEmployeeType.OT}
                            utcTime={props.utcTime}
                            globalHierarchyItemId={props.globalHierarchyItemId}
                            filterByPunchPermissionHierarchy={props.filterByPunchPermissionHierarchy}
                            filterDirectReportsOnly={props.filterDirectReportsOnly}
                        />
                    }
                </Tab>
            </Tabs>
        </Paper>
    )
}

export default DashboardDetail